/* eslint-disable max-len */
import { ReactElement } from 'react';
import NavigationPage from '../../../components/NavigationPage/NavigationPage';
import NavigationTabToolbar from '../../../components/NavigationTabToolbar/NavigationTabToolbar';
import { Tabs_MDE_OTSS } from '../../../types/NavigationTabs';
import { MdeOtssPagePropTypes } from '../../../types/propTypes/MdeOtssPagePropTypes';
import { buildUserAccessNavigationTabItems } from '../../../utilities/routeUtilities';
import './MdeOtssPage.css';

const MdeOtssPage = ({
  children,
  isLoading,
  loadingDataId,
  backBarLocation,
  pageClass,
  APIError,
}: MdeOtssPagePropTypes): ReactElement => {
  return (
    <NavigationPage
      heading={'MDE/OTSS'}
      pageClass={`mde-otss-page ${pageClass}`}
      isLoading={isLoading}
      loadingDataId={loadingDataId}
      backBarLocation={backBarLocation}
      headerChild={
        <>
          <p>{/* Description purposefully empty for now */}</p>
          <NavigationTabToolbar
            navigationTabs={buildUserAccessNavigationTabItems(Tabs_MDE_OTSS)}
          />
        </>
      }
      APIError={APIError}
    >
      {children}
    </NavigationPage>
  );
};

export default MdeOtssPage;
